// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"usp-component_uk-open__txhxT","grecaptcha-badge":"usp-component_grecaptcha-badge__lHbIW","usp":"usp-component_usp__YPF8L","usp__item":"usp-component_usp__item__TA24b","usp__link":"usp-component_usp__link__mhQUZ","icon-svg":"usp-component_icon-svg__s88gT","icon":"usp-component_icon__pDzZa"};
    if(module.hot) {
      // 1793877031054
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  